
import { Language } from "@/common/utils/constants";
import { createContext, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

export interface LanguageContext {
  getLanguage: () => Language;
  setLanguage: (language: Language) => void;
  switchLanguage: () => void;
}

const LanguageProvider = ({ children }: any) => {

  const { i18n } = useTranslation();

  const getLanguage = (): Language => {
    
    const cookie = document.cookie
      .split(";")
      .find(a => a.trim().startsWith("locale"));
      
    const result = cookie?.split("=")[1].substring(0, 2) as Language;
  
    return result;
  };
  
  const setLanguage = (language: Language) => {
  
    const host = window.location.hostname;
    const domain = host.substring(host.lastIndexOf(".", host.lastIndexOf(".") - 1) + 1);
  
    i18n.changeLanguage(language);
    document.cookie = `locale=${language === Language.en ? "en" : language === Language.fr ? "fr-ca" : "en"};domain=${domain};path=/`;
  };
  
  const switchLanguage = () => {
  
    const current = getLanguage();

    const switchTo = 
      current === Language.en 
        ? Language.fr 
        : Language.en;
  
    setLanguage(switchTo);
  };

  useEffect(
    () => setLanguage(getLanguage() || Language.en),
    []
  );

  return (
    <LanguageContext.Provider
      value={{
        getLanguage,
        setLanguage,
        switchLanguage
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
export const LanguageContext = createContext<LanguageContext>(undefined!);
export const useLanguage = () => useContext(LanguageContext);
export default LanguageProvider;